import { Grid, Typography, Box } from "@mui/material";
import SignInForm from "./signinForm/signinForm";
import { Link, useSearchParams } from "react-router-dom";
import logoDark from "../../../assets/images/signin/logoDark.png";
import AuthFooter from "../auth-layout/auth-footer";
import "./signin.scss";
import UnderReview from "../../under-review";

const SignIn = () => {
  const [searchParam, setSearchParam] = useSearchParams()
  const status = searchParam.get('status')
  if (status) {
    return <UnderReview status={status} />
  }

  return (
    <>
      <Box className={`signin`}>
        <Grid container>
          {/* Left SignIn Banner Image */}
          <Grid item xl={8} md={6}>
            <Box
              className={`loginBanner`}
              sx={{
                display: {
                  xl: "block",
                  lg: "block",
                  md: "block",
                  sm: "none",
                  xs: "none",
                },
              }}
            ></Box>
          </Grid>

          {/* SignIn main layout  */}
          <Grid item xl={4} md={6} xs={12}>
            <Box className={`loginContainer`}>
              <Box sx={{ textAlign: "center" }} className={`login-logo`}>
                <img src={logoDark} alt="Logo_Dark" className={`loginLogo`} />
              </Box>
              <Box>
                <Typography
                  align="center"
                  className="signinText grey-color"
                  sx={{
                    lineHeight: "48px",
                    fontWeight: 500,
                    fontSize: "40px",
                    marginTop: "20px",
                    marginBottom: "40px",
                    paddingBlock: "20px",
                  }}
                >
                  <span>Sign In</span>
                </Typography>
                {/* Main Sign in form component*/}
                <SignInForm />
              </Box>
              <Typography
                align="center"
                mt={5}
                mb={3}
                className="grey-color fs-16"
              >
                New to DRIVERTOK?{" "}
                <Link
                  to="/signup-users"
                  className={`secondary-color cursor-pointer`}
                  style={{ textDecoration: "none" }}
                >
                  Sign Up
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <AuthFooter />
    </>
  );
};
export default SignIn;
